export default __webpack_public_path__ + "static/lcb-tower-symbol-header-26281b220cc81de8a199661999726a78.png";